import type { AgencyRecentlyUsedItem } from '@saaga/shared/interfaces/agency-recently-used.interface'
import { BotIcon } from 'lucide-react'

import type { SidebarNavItem } from './sidebar-nav-item.interface'

/**
 * Transforms an AgencyRecentlyUsedItem to a SidebarNavItem for display in the sidebar.
 */
export const transformAgencyToNavItem = (agency: AgencyRecentlyUsedItem): SidebarNavItem => ({
  id: agency.id,
  title: agency.presentation_name,
  path: `/chat/${agency.slug}`,
  icon: BotIcon,
  itemType: 'agent',
  isPinned: false,
})
